"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JWT_KEY = void 0;
exports.getToken = getToken;
exports.hasToken = hasToken;
exports.setToken = setToken;
var _storage = require("../storage");
var JWT_KEY = exports.JWT_KEY = 'jwt';
function hasToken() {
  return !!getToken();
}
var storage = _storage.localStorage;

// If we have a JWT_KEY in sessionStorage, use that instead
// used by LoginAsUser modal
if (_storage.sessionStorage.getItem(JWT_KEY)) {
  storage = _storage.sessionStorage;
}
function getToken() {
  return storage.getItem(JWT_KEY);
}
function setToken(token) {
  if (token) {
    storage.setItem(JWT_KEY, token);
  } else {
    storage.removeItem(JWT_KEY);
  }
}